import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm quick-access"
  }, [_c('b-card-title', {
    staticClass: "align-items-center d-flex justify-content-between mb-2 ml-2 mt-1",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('span', [_c('b-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "cursor-fill",
      "variant": "primary"
    }
  }), _vm._v(" Atalhos ")], 1), _vm.editing ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "quick-access-edit",
    attrs: {
      "title": "Editar atalhos",
      "variant": "link",
      "aria-label": "Editar atalhos"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.openShortcutModal.apply(null, arguments);
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "pencil"
    }
  })], 1) : _vm._e()], 1), _c('b-card-body', [_vm.selectedShortcuts.length ? _c('div', {
    staticClass: "quick-access-list"
  }, _vm._l(_vm.selectedShortcuts, function (shortcut) {
    return _c('button', {
      key: shortcut.id,
      staticClass: "border-0 rounded p-2 text-left quick-access-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.navigateToShortcut(shortcut.id);
        }
      }
    }, [_c('ArrowRight', {
      staticClass: "svg-icon mr-1",
      attrs: {
        "size": 16
      }
    }), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(shortcut.shortcutLabel))])], 1);
  }), 0) : _c('p', {
    staticClass: "quick-access-empty"
  }, [_vm._v("Nenhum atalho selecionado.")])]), _c('b-modal', {
    attrs: {
      "id": "dashboard-shortcuts-modal",
      "title": "Editar atalhos",
      "centered": "",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.onShortcutModalHidden
    }
  }, [_c('label', {
    staticClass: "font-weight-bold",
    attrs: {
      "for": "dashboard-shortcuts-search"
    }
  }, [_vm._v(" Buscar menu ")]), _c('b-input-group', {
    staticClass: "mb-4"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "search"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "id": "dashboard-shortcuts-search",
      "type": "search",
      "autocomplete": "off",
      "placeholder": "Digite o nome do menu"
    },
    model: {
      value: _vm.shortcutSearch,
      callback: function callback($$v) {
        _vm.shortcutSearch = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "shortcutSearch"
    }
  })], 1), _c('div', {
    staticClass: "shortcut-options"
  }, [_vm._l(_vm.filteredShortcutGroups, function (group) {
    return _c('section', {
      key: group.name,
      staticClass: "shortcut-group"
    }, [_c('h6', {
      staticClass: "shortcut-group-title"
    }, [_vm._v(_vm._s(group.name))]), _vm._l(group.shortcuts, function (shortcut) {
      return _c('b-form-checkbox', {
        key: shortcut.id,
        staticClass: "shortcut-option",
        attrs: {
          "value": shortcut.id,
          "disabled": _vm.isShortcutDisabled(shortcut.id)
        },
        model: {
          value: _vm.shortcutDraft,
          callback: function callback($$v) {
            _vm.shortcutDraft = $$v;
          },
          expression: "shortcutDraft"
        }
      }, [_vm._v(" " + _vm._s(shortcut.label) + " ")]);
    })], 2);
  }), !_vm.filteredShortcutGroups.length ? _c('div', {
    staticClass: "shortcut-no-results"
  }, [_vm._v(" Nenhum menu habilitado encontrado. ")]) : _vm._e()], 2), _c('div', {
    staticClass: "align-items-center d-flex justify-content-between mt-5"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.shortcutDraft.length) + " de " + _vm._s(_vm.maxShortcuts) + " atalhos selecionados ")]), _vm.shortcutDraft.length >= _vm.maxShortcuts ? _c('small', {
    staticClass: "d-block text-muted"
  }, [_vm._v(" Desmarque um atalho para selecionar outro. ")]) : _vm._e()]), _c('div', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "light",
      "disabled": _vm.savingShortcuts
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('dashboard-shortcuts-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.savingShortcuts
    },
    on: {
      "click": _vm.saveShortcuts
    }
  }, [_vm.savingShortcuts ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Salvar ")], 1)], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };